import { ProEditReasons } from '@mp/graphql/generated/graphql';

/** Converts PascalCase/camelCase to a readable label (e.g. "ForgotToClockIn" → "Forgot To Clock In") */
function toReadableLabel(pascalOrCamel: string): string {
  return pascalOrCamel
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/^./, (c) => c.toUpperCase());
}

export const EDIT_CLOCK_TIMES_REASONS = (
  Object.entries(ProEditReasons) as [keyof typeof ProEditReasons, ProEditReasons][]
)
  .map(([key, value]) => ({
    value,
    label: toReadableLabel(key),
  }))
  .sort((a, b) =>
    a.value === ProEditReasons.Other ? 1 : b.value === ProEditReasons.Other ? -1 : 0,
  );

export const REASON_OTHER_VALUE = ProEditReasons.Other;
